export var SourceType;
(function (SourceType) {
    SourceType["VISUAL"] = "visual";
    SourceType["SOUND"] = "sound";
})(SourceType || (SourceType = {}));
